import { API_BASE_URL } from "@/config";
import { PREPOPULATE_INPUT } from "@/utils/prepopulate_input.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import { validateToken } from "@/utils/auth";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import Swal from "sweetalert2";

export default {
    name: 'TrustTrusteesSearch',
    mixins: [MAIN_CONTROLLER, PREPOPULATE_INPUT],
    data() {
        return {
            form: {
                trust_number: '',
                masters_office: ''
            }
        };
    },
    components: {
        BreadCrumb,
        ClientLogo
    },
    computed: {
        workflow_id() {
          return this.$store.getters.get_workflow_id;
        }
    },
    methods: {
        submit_trust_trustees() {
            if (!this.form.trust_number.trim() || !this.form.masters_office.trim()) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Both Trust Number and Master\'s Office are required',
                    timer: 3000,
                    showConfirmButton: false
                });
                return false;
            }
            const trust_number_regex = /^\d{6}\/\d{4}$/;
            if (!trust_number_regex.test(this.form.trust_number)) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Trust Number must be in the format 000000/YYYY',
                    timer: 3000,
                    showConfirmButton: false
                });
                return false;
            }
            this.trust_trustees_search_api();
        },
        trust_trustees_search_api() {
            const TOKEN = localStorage.getItem('token');
            const TRUSTEES_SEARCH_API = `${API_BASE_URL}/verify_api/compliance_verification/trust_trustees_search/`;

            $.ajax({
                url: TRUSTEES_SEARCH_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    trust_number: this.form.trust_number,
                    masters_office: this.form.masters_office,
                    workflow_id: this.workflow_id,
                    on_behalf_application: this.$route.name === 'behalf_application' ? true : false,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    Swal.fire({
                        icon: 'success',
                        title: 'Successful',
                        text: 'Trustees Found Successfully',
                        timer: 3000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {
                        this.completeService();
                    });
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error_message,
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
